import {
  RadiusOfOperationMiles,
  RecentVehicleLocations,
  MilesByState,
  MilesByZipcode,
  ActiveVehicles,
  MilesByMonth,
  LookbackCoverage,
  LookbackRequestResult,
} from 'interfaces/ISummaryReport'
import request from 'tools/request'

export const summaryReportHeaderKpi = async (
  carrierId: string,
  carrierCode: string,
  codeValue: string,
  eldVendor: string
) => {
  const res = await request.get(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/${carrierId}/header-kpi?&carrierCode=${carrierCode}&codeValue=${codeValue}&eldVendor=${eldVendor}`
  )
  return res?.data
}

/* Radius of Operation */
export const getRecentVehicleLocations = async (
  carrierId: string,
  sinceHours?: number,
  size?: number,
  page?: number
): Promise<RecentVehicleLocations> => {
  const res = await request.get<RecentVehicleLocations>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/${carrierId}/recent-vehicle-locations`,
    {
      params: {
        sinceHours,
        size,
        page,
      },
    }
  )
  return res?.data
}

export const getMilesByState = async (
  carrierId: string,
  startDate: string,
  endDate: string
): Promise<MilesByState> => {
  const res = await request.get<MilesByState>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/${carrierId}/mileage/by-state`,
    {
      params: {
        startDate,
        endDate,
      },
    }
  )
  return res?.data
}

export const getMilesByZipcode = async (
  carrierId: string,
  startDate: string,
  endDate: string,
  size?: number,
  page?: number
): Promise<MilesByZipcode> => {
  const res = await request.get<MilesByZipcode>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/${carrierId}/mileage/by-zipcode`,
    {
      params: {
        startDate,
        endDate,
        size,
        page,
      },
    }
  )
  return res?.data
}

export const getRadiusOfOperationMileage = async (
  carrierId: string,
  startDate: string,
  endDate: string
): Promise<RadiusOfOperationMiles> => {
  const res = await request.get<RadiusOfOperationMiles>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/${carrierId}/mileage/by-radius`,
    {
      params: {
        startDate,
        endDate,
      },
    }
  )
  return res?.data
}

export const getActiveVehicles = async (
  carrierId: string,
  startDate: string,
  endDate: string
): Promise<ActiveVehicles> => {
  const res = await request.get<ActiveVehicles>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/${carrierId}/active-vehicles`,
    {
      params: {
        startDate,
        endDate,
      },
    }
  )
  return res?.data
}

export const getMilesByMonth = async (
  carrierId: string,
  startDate: string,
  endDate: string,
  useKilometers?: boolean
): Promise<MilesByMonth> => {
  const res = await request.get<MilesByMonth>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/${carrierId}/mileage/by-month`,
    {
      params: {
        startDate, 
        endDate,
        ...(useKilometers !== undefined && { useKilometers })
      },
    }
  )
  return res?.data
}

export const getLookbackCoverage = async (
  carrierId: string,
  carrierCode: string,
  codeValue: string
): Promise<LookbackCoverage> => {
  const res = await request.get<LookbackCoverage>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/${carrierId}/lookback-coverage`,
    {
      params: {
        carrierCode,
        codeValue,
      },
    }
  )
  return res?.data
}

export const requestLookback = async (
  carrierId: string,
  carrierCode: string,
  codeValue: string,
  startDate: string,
  endDate: string
): Promise<LookbackRequestResult> => {
  const res = await request.post<LookbackRequestResult>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/${carrierId}/lookback-request`,
    { startDate, endDate },
    {
      params: {
        carrierCode,
        codeValue,
      },
    }
  )
  // The request interceptor turns a 401 into undefined; without this the modal reports "submitted".
  if (!res?.data) {
    throw new Error('lookback request was not accepted')
  }
  return res.data
}
